<template>
  <ComplaintFormStepper />
</template>

<script>
import { mapMutations } from 'vuex'

// import JSON_API_CONSTANTS from '@/js/helper/jsonapi-constants.js'
import FORM_CONSTANTS from '@/js/components/Forms/ComplaintForm/_store-module/constants.js'
import FORM_STORE_MODULE from '@/js/components/Forms/ComplaintForm/_store-module'
import FORM_MUTATION from '@/js/components/Forms/ComplaintForm/_store-module/mutation-types.js'

import ComplaintFormStepper from '@/js/components/Forms/ComplaintForm/ComplaintFormStepper.vue'

export default {
  name: 'ComplaintForm',
  components: {
    ComplaintFormStepper,
  },
  props: {
    data: {
      type: String,
      default: '',
    },
  },
  created() {
    try {
      // const data = JSON.parse(
      //   document.getElementById(FORM_CONSTANTS.ELEMENT_ID).getAttribute(JSON_API_CONSTANTS.DATA),
      // )

      const data = JSON.parse(this.data)

      if (!this.$store.hasModule(FORM_CONSTANTS.STORE_ID)) {
        this.$store.registerModule(FORM_CONSTANTS.STORE_ID, FORM_STORE_MODULE)
      }
      this.setSourceData(data)
    } catch (error) {
      console.error(error)
    }
  },
  methods: {
    ...mapMutations(FORM_CONSTANTS.STORE_ID, {
      setSourceData: FORM_MUTATION.SET_SOURCE_DATA,
    }),
  },
}
</script>
